import React, { useState, useEffect } from 'react';
import '../styles/FAQPage.css';

// faqData'yı component dışına taşıyoruz
const faqData = [
    {
        question: "Sigara kullanımı meme kanseri riskini artırır mı?",
        answer: "Evet. Sigara kullanımı, özellikle genç yaşta başlanıp uzun süre devam ettiğinde meme kanseri riskini artırır. Nikotin ve diğer zararlı kimyasallar meme dokusunda hücresel değişikliklere neden olabilir.",
        source: "American Cancer Society. (2023). Tobacco and Cancer. https://www.cancer.org"
    },
    {
        question: "Düzenli egzersiz yapmak meme kanseri riskini azaltır mı?",
        answer: "Evet. Haftada en az 150 dakika orta düzeyde fiziksel aktivite yapan kadınlarda meme kanseri riski daha düşüktür.",
        source: "World Health Organization. (2020). Physical activity. https://www.who.int"
    },
    {
        question: "Alkol tüketimi meme sağlığını etkiler mi?",
        answer: "Evet. Günde bir kadeh alkol bile meme kanseri riskini artırabilir. Alkol östrojen seviyelerini yükselterek hücre büyümesini tetikleyebilir.",
        source: "Harvard T.H. Chan School of Public Health. (2021). Alcohol and Breast Cancer. https://www.hsph.harvard.edu"
    },
    {
        question: "İlk adet yaşının erken olması meme kanseri riskini etkiler mi?",
        answer: "Evet. 12 yaşından önce adet gören kadınlarda, daha geç yaşta adet görenlere göre meme kanseri riski biraz daha yüksektir.",
        source: "Centers for Disease Control and Prevention (CDC). (2022). Breast Cancer Risk Factors. https://www.cdc.gov"
    },
    {
        question: "Menopoz yaşı meme kanseri riski ile ilişkili midir?",
        answer: "Evet. Geç menopoz (55 yaş ve sonrası) olan kadınlarda meme kanseri riski artar çünkü östrojen maruziyeti daha uzun sürer.",
        source: "National Cancer Institute. (2023). Breast Cancer Risk. https://www.cancer.gov"
    },
    {
        question: "Cerrahi menopoz meme kanseri riskini nasıl etkiler?",
        answer: "Yumurtalıkların alınmasıyla erken yaşta girilen cerrahi menopoz, hormon seviyelerini düşürdüğü için meme kanseri riskini azaltabilir.",
        source: "Collaborative Group on Hormonal Factors in Breast Cancer. (2012). The Lancet Oncology."
    },
    {
        question: "Emzirmek meme kanseri riskini azaltır mı?",
        answer: "Evet. Emzirme süresi uzadıkça meme kanseri riski azalmaktadır. Özellikle toplamda 12 ay ve üzeri emzirme koruyucu etkidedir.",
        source: "World Cancer Research Fund. (2018). Diet, Nutrition, Physical Activity and Breast Cancer."
    },
    {
        question: "Hiç emzirmemek meme kanseri riskini artırır mı?",
        answer: "Evet. Hiç emzirmemek, meme kanseri riskini az da olsa artırabilir çünkü emzirme hormon dengesini olumlu yönde etkiler.",
        source: "American Institute for Cancer Research. (2019). Breastfeeding and Cancer Risk."
    },
    {
        question: "En ideal emzirme süresi nedir?",
        answer: "Dünya Sağlık Örgütü en az 6 ay sadece anne sütü, ardından 2 yaşına kadar tamamlayıcı emzirme önermektedir. Ancak her emzirme süresi faydalıdır.",
        source: "World Health Organization. (2020). Infant and young child feeding."
    },
    {
        question: "BKİ değeri meme kanseri riskini etkiler mi?",
        answer: "Evet. Özellikle menopoz sonrası kadınlarda yüksek BKİ (obezite), meme kanseri riskini artırmaktadır.",
        source: "World Cancer Research Fund. (2018). Diet, Nutrition, Physical Activity and Breast Cancer."
    },
    {
        question: "Obezite ile meme kanseri arasında nasıl bir ilişki vardır?",
        answer: "Obezite, östrojen seviyelerini yükselttiği için özellikle menopoz sonrası kadınlarda meme kanseri riskini artırır.",
        source: "American Cancer Society. (2022). Obesity and Cancer. https://www.cancer.org"
    },
    {
        question: "Sütyen bedeni meme kanseri riskiyle doğrudan ilişkili midir?",
        answer: "Hayır. Sütyen bedeni veya kullanım şekli doğrudan meme kanseri riskini artırmaz. Ancak meme dokusunun yoğunluğu önemli bir risk faktörüdür.",
        source: "National Cancer Institute. (2023). Breast Density and Cancer Risk. https://www.cancer.gov"
    },
    {
        question: "Düzenli olarak KKMM yapmak ne sağlar?",
        answer: "Kişinin meme dokusunu tanımasını ve herhangi bir değişikliği erken fark etmesini sağlar.",
        source: "Türkiye Meme Hastalıkları Dernekleri Federasyonu. (2022). KKMM Rehberi."
    },
    {
        question: "Mamografi ne zaman yapılmalıdır?",
        answer: "40 yaşından itibaren her yıl mamografi önerilmektedir. Aile öyküsü olanlarda bu yaş daha erkene çekilebilir.",
        source: "Sağlık Bakanlığı. (2022). Meme Kanseri Taramaları. https://hsgm.saglik.gov.tr"
    },
    {
        question: "Mamografi ve KKMM birlikte kullanıldığında ne avantaj sağlar?",
        answer: "Mamografi ile görüntüleme sağlanırken, KKMM kişinin kendi farkındalığını artırarak değişiklikleri daha erken fark etmesini sağlar.",
        source: "World Health Organization. (2019). Breast cancer screening."
    },
    {
        question: "Hormon Replasman Tedavisi (HRT) uzun süreli kullanıldığında meme kanseri riskini artırabilir mi?",
        answer: "Evet. Özellikle 5 yıl ve üzeri sürede kombine HRT (östrojen+progesteron) kullanan kadınlarda meme kanseri riski artmaktadır.",
        source: "Chlebowski, R. T., & Anderson, G. L. (2012). Menopausal hormone therapy and breast cancer risk: An evidence-based approach. Nature Reviews Endocrinology, 8(6), 340–349. https://doi.org/10.1038/nrendo.2011.202"
    },
    {
        question: "Doğum kontrol hapı (oral kontraseptif) kullanımı meme kanseri riskini etkiler mi?",
        answer: "Evet. Oral kontraseptif kullanımı sırasında ve bırakıldıktan sonraki birkaç yıl içinde meme kanseri riskinde hafif artış görülebilir. Ancak bu artış genellikle geçicidir.",
        source: "Morch, L. S., Skovlund, C. W., Hannaford, P. C., et al. (2017). Contemporary hormonal contraception and the risk of breast cancer. New England Journal of Medicine, 377(23), 2228–2239. https://doi.org/10.1056/NEJMoa1700732"
    },
    {
        question: "Bitkisel veya hormon benzeri takviyeler kullanmak meme sağlığı açısından riskli olabilir mi?",
        answer: "Evet. Özellikle fitoöstrojen içeren bitkisel takviyeler, hormonal dengeyi etkileyebilir. Bu nedenle sağlık profesyoneline danışılmadan kullanılmamalıdır.",
        source: "Posadzki, P., Watson, L., & Ernst, E. (2013). Contamination and adulteration of herbal medicinal products (HMPs): An overview of systematic reviews. European Journal of Clinical Pharmacology, 69, 295–307. https://doi.org/10.1007/s00228-012-1353-z"
    },
    {
        question: "Kronik hastalıklar için kullanılan ilaçlar meme sağlığı taramalarını etkiler mi?",
        answer: "Evet. Bazı ilaçlar hormonal düzeyleri değiştirebilir veya meme dokusunda yoğunluk artışına neden olarak mamografi görüntülerini etkileyebilir. Bu nedenle kullanılan tüm ilaçlar doktora bildirilmelidir.",
        source: "American Cancer Society. (2023). Drugs that may interfere with breast imaging. Retrieved from https://www.cancer.org"
    },
    {
        question: "Mamografi öncesinde kullanılan ilaçlar radyolojik sonuçları etkileyebilir mi?",
        answer: "Özellikle hormon içerikli ilaçlar memede ödem ya da yoğunluk oluşturabilir. Bu durum görüntülemeyi zorlaştırabileceği için mamografi öncesinde sağlık çalışanına bilgi verilmelidir.",
        source: "D'Orsi, C. J., Sickles, E. A., Mendelson, E. B., et al. (2013). ACR BI-RADS® Atlas: Breast Imaging Reporting and Data System. American College of Radiology."
    },
    {
        question: "Bazı ilaçlar meme sağlığını etkileyebilir mi?",
        answer: "Evet. Özellikle hormon tedavileri ve doğum kontrol hapları gibi ilaçlar, östrojen düzeylerini etkileyerek meme dokusunda değişikliklere neden olabilir.",
        source: "American Cancer Society. (2021). Hormone Therapy and Cancer Risk. https://www.cancer.org"
    },
    {
        question: "İlaç kullanım geçmişi neden sağlık çalışanlarıyla paylaşılmalıdır?",
        answer: "Çünkü bazı ilaçlar meme yapısını etkileyebilir, bu da muayene veya mamografi gibi taramalarda yanlış pozitif ya da negatif sonuçlara yol açabilir.",
        source: "National Institutes of Health. (2020). Medication History and Screening Accuracy. https://www.nih.gov"
    },
    {
        question: "Memede ele gelen sert kitle ne anlama gelebilir?",
        answer: "Memede hissedilen sert, düzensiz kenarlı ve hareketsiz bir kitle, malign (kanserli) bir oluşumun belirtisi olabilir. Özellikle ağrısız olan ve zamanla büyüyen kitleler, meme kanseri açısından risk taşıdığından, bu tür bir bulgu fark edildiğinde vakit kaybetmeden bir sağlık kuruluşuna başvurulması önemlidir. Erken dönemde tespit edilen kitleler, tedavi açısından çok daha başarılı sonuçlar verir.",
        source: "Mayo Clinic. (2022). Breast lumps. https://www.mayoclinic.org/diseases-conditions/breast-cancer/in-depth/breast-lumps/art-20044838"
    },
    {
        question: "Kitle hissedildiğinde hangi sağlık birimine başvurulmalıdır?",
        answer: "Aile hekimi veya bir genel cerrahi uzmanına başvurulmalı ve görüntüleme tetkikleri istenmelidir.",
        source: "Sağlık Bakanlığı. (2023). Meme Sağlığı Bilgilendirme Rehberi."
    },
    {
        question: "Kitle her zaman kanser anlamına mı gelir?",
        answer: "Hayır. Fibroadenom gibi iyi huylu kitleler de olabilir ancak mutlaka değerlendirme gerektirir.",
        source: "American Cancer Society. (2022). Benign Breast Conditions."
    },
    {
        question: "Meme sağlığı ile ilgili en güvenilir bilgi kaynağı nedir?",
        answer: "Sağlık profesyonelleri ve resmi sağlık kurumlarının yayınlarıdır.",
        source: "World Health Organization. (2021). Health Information Sources."
    },
    {
        question: "Broşür, afiş gibi yazılı materyaller bilgilendirmede etkili midir?",
        answer: "Evet. Görsel içerikler farkındalık artırmada ve öğrenilen bilgilerin akılda kalıcılığında etkilidir.",
        source: "National Cancer Institute. (2020). Health Education Strategies."
    },
    {
        question: "Sosyal medya meme sağlığı bilgisinde güvenilir midir?",
        answer: "Sadece doğruluğu teyit edilmiş kaynaklar kullanıldığında. Aksi takdirde yanlış bilgi riski vardır.",
        source: "Pew Research Center. (2022). Online Health Information Behavior."
    },
    {
        question: "Daha önce kendi kendine meme muayenesi (KKMM) bilmek kanser riskini düşürür mü?",
        answer: "Hayır. KKMM yapmak erken tanı açısından faydalıdır, ancak doğrudan kanser gelişme riskini düşürmez.",
        source: "American Cancer Society. (2023). Breast Cancer Early Detection. https://www.cancer.org"
    },
    {
        question: "Kadın olmak meme kanseri riskini artırır mı?",
        answer: "Evet. Kadın olmak en önemli risk faktörlerinden biridir çünkü meme kanseri vakalarının çoğu kadınlarda görülmektedir.",
        source: "World Health Organization. (2022). Breast Cancer: Key Facts. https://www.who.int"
    },
    {
        question: "İlk doğumu 30 yaşından sonra yapmak meme kanseri riskini artırır mı?",
        answer: "Evet. İlk doğumun 30 yaşından sonra olması, östrojen maruziyet süresini uzatabileceği için riski artıran etkenlerden biridir.",
        source: "Centers for Disease Control and Prevention (CDC). (2022). What Are the Risk Factors for Breast Cancer?"
    },
    {
        question: "Meme kanserindeki ilk belirti genellikle ağrı ile başlar ifadesi doğru mudur?",
        answer: "Hayır. Meme kanseri genellikle ağrısız bir kitle ile başlar. Ağrı genellikle ileri evrelerde görülür.",
        source: "American Cancer Society. (2023). Signs and Symptoms of Breast Cancer. https://www.cancer.org"
    },
    {
        question: "Memede ele gelen şişlik meme kanserinin belirtisi olabilir mi?",
        answer: "Evet. Memede ele gelen sert ve hareketsiz kitle, meme kanserinin en sık görülen belirtilerindendir.",
        source: "National Cancer Institute. (2021). Breast Changes and Conditions. https://www.cancer.gov"
    },
    {
        question: "Meme başından kanlı akıntı kanser belirtisi olabilir mi?",
        answer: "Evet. Özellikle tek memeden, kendiliğinden gelen kanlı akıntılar kanser açısından değerlendirilmelidir.",
        source: "Mayo Clinic. (2022). Nipple discharge: When to worry. https://www.mayoclinic.org"
    },
    {
        question: "İlk âdetin erken yaşta olması meme kanseri riskini artırır mı?",
        answer: "Evet. Erken yaşta âdet görmek, yaşam boyu östrojen maruziyet süresini uzatarak meme kanseri riskini artırabilir.",
        source: "National Cancer Institute. (2021). Breast Cancer Risk Factors. https://www.cancer.gov"
    },
    {
        question: "Yakın akrabada meme kanseri olması riski artırır mı?",
        answer: "Evet. Özellikle birinci derece akrabalarda (anne, kız kardeş, teyze) meme kanseri öyküsü varsa risk belirgin şekilde artar.",
        source: "American Cancer Society. (2023). Breast Cancer Risk and Prevention."
    },
    {
        question: "Daha önce iyi huylu meme hastalığı geçirmek kanser riskini artırır mı?",
        answer: "Evet. Özellikle atipik hücre içeren iyi huylu lezyonlar, ileride kanser gelişme riskini artırabilir.",
        source: "Susan G. Komen Foundation. (2022). Benign Breast Conditions."
    },
    {
        question: "Bir memede kanser olması, diğer memede de kanser gelişme riskini artırır mı?",
        answer: "Evet. Özellikle hormon reseptör pozitif tümörlerde ikinci memede kanser gelişme riski artabilir.",
        source: "American Cancer Society. (2023). Second Cancers After Breast Cancer."
    },
    {
        question: "Hormon tedavisi almak meme kanseri riskini artırır mı?",
        answer: "Evet. Uzun süreli hormon replasman tedavisi (özellikle östrojen ve progesteron birlikte) meme kanseri riskini artırır.",
        source: "Chlebowski, R. T., et al. (2010). Breast cancer after use of estrogen plus progestin therapy. NEJM."
    },
    {
        question: "Doğum kontrol hapı kullanımı meme kanseri riskini artırır mı?",
        answer: "Evet. Doğum kontrol hapları kullanımı riski hafif artırabilir, ancak bu risk genellikle ilacın bırakılmasından sonra azalır.",
        source: "National Cancer Institute. (2021). Contraceptives and Breast Cancer."
    },
    {
        question: "Radyasyona maruz kalmak meme kanseri riskini artırır mı?",
        answer: "Evet. Özellikle göğüs bölgesine genç yaşta radyoterapi uygulanması ileriki yıllarda riski artırır.",
        source: "American Cancer Society. (2023). Radiation Exposure and Cancer Risk."
    },
    {
        question: "Şişmanlık ve yağlı beslenme meme kanseri riskini artırır mı?",
        answer: "Evet. Özellikle menopoz sonrası kadınlarda yağ dokusunda östrojen üretimi arttığı için risk yüksektir.",
        source: "World Cancer Research Fund. (2020). Obesity and Breast Cancer Risk."
    },
    {
        question: "Bebeğini hiç emzirmemek veya kısa süre emzirmek meme kanseri riskini artırır mı?",
        answer: "Evet. Emzirmek meme dokusunun farklılaşmasını sağlar ve uzun emzirme süresi koruyucu etki yaratır.",
        source: "Collaborative Group on Hormonal Factors in Breast Cancer. (2002). Breast cancer and breastfeeding: a pooled analysis. Lancet."
    },
    {
        question: "Koltuk altında ele gelen şişlik meme kanserinin belirtisi olabilir mi?",
        answer: "Evet. Meme kanseri koltuk altındaki lenf nodlarına yayılabilir, bu da şişlik olarak hissedilebilir.",
        source: "American Cancer Society. (2023). Breast Cancer Symptoms."
    },
    {
        question: "Meme başının içe doğru çekilmesi meme kanseri belirtisi olabilir mi?",
        answer: "Evet. Özellikle yeni başlayan içe çekilmeler meme altında gelişen kitleye işaret edebilir.",
        source: "Mayo Clinic. (2022). Breast Symptoms. https://www.mayoclinic.org"
    },
    {
        question: "Tek memede sarkma veya asimetri meme kanseri işareti olabilir mi?",
        answer: "Evet. Ani gelişen tek taraflı şekil değişiklikleri cilt altındaki oluşumların etkisiyle ortaya çıkabilir.",
        source: "National Cancer Institute. (2021). Recognizing Breast Changes."
    },
    {
        question: "Meme derisinde kuruluk, kabuklanma veya buruşukluk tehlikeli midir?",
        answer: "Evet. Portakal kabuğu görünümü, inflamatuvar meme kanseri gibi agresif türlerin habercisi olabilir.",
        source: "Breastcancer.org. (2023). Inflammatory Breast Cancer."
    },
    {
        question: "Memede sıcaklık artışı, kızarıklık ve yara meme kanseri belirtisi olabilir mi?",
        answer: "Evet. Bu durumlar özellikle inflamatuvar meme kanserinde görülür ve hızla tıbbi değerlendirme gerektirir.",
        source: "National Comprehensive Cancer Network. (2022). Inflammatory Breast Cancer Guidelines."
    },
    {
        question: "Mamografi kaç yaşından itibaren önerilir?",
        answer: "40 yaş ve üzeri kadınlara yılda bir kez mamografi taraması önerilmektedir.",
        source: "American Cancer Society. (2023). Breast Cancer Screening Guidelines. https://www.cancer.org"
    },
    {
        question: "Meme kanserinin ilk belirtisi her zaman ağrı mıdır?",
        answer: "Hayır. Meme kanseri genellikle ağrısız bir kitle ile başlar. Ağrı nadiren ilk belirtidir.",
        source: "National Cancer Institute. (2022). Breast Cancer Symptoms. https://www.cancer.gov"
    },
    {
        question: "Ailede meme kanseri öyküsü riski artırır mı?",
        answer: "Evet. Özellikle anne, kız kardeş veya teyze gibi birinci derece akrabalarda meme kanseri öyküsü varsa risk artar.",
        source: "Centers for Disease Control and Prevention (CDC). (2023). Breast Cancer Risk Factors."
    },
    {
        question: "KKMM yapmak tanı koymak için yeterli midir?",
        answer: "Hayır. KKMM yalnızca olası değişiklikleri erken fark etmek içindir. Tanı için mutlaka sağlık profesyoneline başvurulmalıdır.",
        source: "Türkiye Meme Hastalıkları Dernekleri Federasyonu. (2022). Meme sağlığı el kitabı."
    },
    {
        question: "Mamografi sırasında radyasyon riski var mıdır?",
        answer: "Mamografide verilen radyasyon dozu çok düşüktür ve tıbbi faydaları risklerden fazladır.",
        source: "Radiological Society of North America. (2022). Patient Safety in Mammography."
    },
    {
        question: "Meme kanserinde erken teşhis tedavi başarısını artırır mı?",
        answer: "Evet. Erken teşhis edilen meme kanseri vakalarında tümör henüz yayılmadan müdahale edilebilir, bu da tedavi başarısını %90'ın üzerine çıkarabilir.",
        source: "World Health Organization. (2022). Breast cancer: early diagnosis and screening. https://www.who.int/news-room/fact-sheets/detail/breast-cancer"
    },
    {
        question: "Erken tanı, meme kanserine bağlı ölüm oranını azaltır mı?",
        answer: "Evet. Erken tanı sayesinde meme kanserine bağlı mortalite oranları önemli ölçüde düşmektedir.",
        source: "American Cancer Society. (2023). Breast Cancer Survival Rates. https://www.cancer.org"
    },
    {
        question: "Erken teşhis meme kanseri tedavisinde yaşam süresini etkiler mi?",
        answer: "Evet. Erken teşhis edilen kadınların ortalama sağkalım süresi daha uzun olmaktadır. Tedavi daha az invaziv yöntemlerle yapılabilir.",
        source: "National Cancer Institute. (2022). Breast Cancer Treatment (PDQ®)–Patient Version. https://www.cancer.gov"
    },
    {
        question: "Mamografi işlemi nasıl gerçekleştirilir?",
        answer: "Mamografi, memenin iki plaka arasına yerleştirilerek düşük doz X-ışını ile görüntülenmesiyle yapılır. Bu yöntem meme dokusundaki anormalliklerin erken saptanmasını sağlar.",
        source: "Radiological Society of North America. (2023). Mammography. https://www.radiologyinfo.org/en/info/mammo"
    },
    {
        question: "Mamografi kimlere önerilir?",
        answer: "40 yaş ve üzerindeki kadınlara her yıl düzenli olarak mamografi taraması önerilmektedir. Bu yaş grubunda risk arttığı için erken teşhis açısından önemlidir.",
        source: "American Cancer Society. (2023). Breast Cancer Early Detection and Diagnosis. https://www.cancer.org"
    },
    {
        question: "Mamografi çekimine giderken deodorant veya losyon kullanılmalı mı?",
        answer: "Hayır. Mamografi öncesi koltuk altına ve meme bölgesine deodorant, losyon, parfüm veya pudra sürülmemelidir çünkü bu maddeler görüntüde lekelere neden olabilir.",
        source: "Mayo Clinic. (2023). Mammogram preparation. https://www.mayoclinic.org"
    },
    {
        question: "Mamografi çekimi için en uygun zaman ne zamandır?",
        answer: "Adet gören kadınlar için en uygun zaman, adet döneminin 7–10. günleri arasıdır. Bu dönemde memeler daha az hassas olur, çekim daha konforlu gerçekleşir.",
        source: "Türkiye Meme Hastalıkları Dernekleri Federasyonu. (2022). Meme Sağlığı Bilgilendirme Rehberi."
    },
    {
        question: "Mamografi taramasına kaç yaşında başlanmalıdır?",
        answer: "Mamografi taramasına genellikle 40 yaşından itibaren başlanmalıdır. Bu yaş grubundaki kadınlarda meme kanseri görülme sıklığı arttığı için düzenli tarama önerilir.",
        source: "American Cancer Society. (2023). Breast Cancer Early Detection Guidelines. https://www.cancer.org"
    },
    {
        question: "Mamografi taramaları ne sıklıkla yapılmalıdır?",
        answer: "40 yaş ve üzeri kadınlar için mamografi taraması yılda bir kez önerilmektedir. Risk faktörlerine bağlı olarak daha sık tarama gerekebilir.",
        source: "World Health Organization. (2022). Breast cancer: screening and early diagnosis. https://www.who.int"
    },
    {
        question: "Ailesinde meme kanseri olan biri mamografiye daha erken başlamalı mı?",
        answer: "Evet. Yüksek risk grubundaki kişiler (örneğin annesi veya kız kardeşi meme kanseri tanısı almış olanlar) için mamografiye 30-35 yaşlarında başlanması önerilebilir. Bu kişiler için doktor tarafından bireyselleştirilmiş bir tarama planı yapılmalıdır.",
        source: "National Comprehensive Cancer Network. (2023). Breast Cancer Screening Guidelines. https://www.nccn.org"
    },
    {
        question: "Yaş ilerledikçe meme kanseri riski artar mı?",
        answer: "Evet. Meme kanseri riski yaşla birlikte artar. Özellikle 50 yaş üzerindeki kadınlarda risk önemli ölçüde yükselir.",
        source: "American Cancer Society. (2023). Breast Cancer Risk Factors. https://www.cancer.org"
    },
    {
        question: "İlk doğumunu 30 yaşından sonra yapan kadınlarda meme kanseri riski artar mı?",
        answer: "Evet. İlk doğumun ileri yaşta olması meme kanseri riskini artıran faktörlerden biridir.",
        source: "Centers for Disease Control and Prevention. (2022). What Are the Risk Factors for Breast Cancer? https://www.cdc.gov"
    },
    {
        question: "Menopoza geç yaşta girmek meme kanseri riskini etkiler mi?",
        answer: "Evet. Menopoza 55 yaşından sonra giren kadınlarda östrojen maruziyeti süresi uzadığı için meme kanseri riski artar.",
        source: "World Health Organization. (2022). Breast Cancer Factsheet. https://www.who.int"
    },
    {
        question: "12 yaşından önce adet görmek meme kanseri riskini artırır mı?",
        answer: "Evet. Erken yaşta adet görmek, östrojen maruziyetini uzattığı için riski artırabilir.",
        source: "Mayo Clinic. (2023). Breast Cancer Risk Factors. https://www.mayoclinic.org"
    },
    {
        question: "Bir memede kanser varsa diğer memede de kanser görülme riski var mıdır?",
        answer: "Evet. Geçmişte meme kanseri geçirmiş bir kadında, diğer memede de kanser gelişme riski daha yüksektir.",
        source: "National Cancer Institute. (2023). Second Primary Cancers. https://www.cancer.gov"
    },
    {
        question: "Ailede meme kanseri öyküsü olanlarda risk artar mı?",
        answer: "Evet. Özellikle birinci derece akrabalarda (anne, kız kardeş) meme kanseri varsa risk artar.",
        source: "National Breast Cancer Foundation. (2023). Genetic Risk Factors. https://www.nationalbreastcancer.org"
    },
    {
        question: "Şişmanlık meme kanseri için bir risk faktörü müdür?",
        answer: "Evet. Özellikle menopoz sonrası obezite, meme kanseri riskini önemli ölçüde artırır.",
        source: "American Cancer Society. (2023). Body Weight and Cancer Risk. https://www.cancer.org"
    },
    {
        question: "Doğum kontrol hapı kullanmak meme kanseri riskini etkiler mi?",
        answer: "Evet. Özellikle uzun süreli oral kontraseptif kullanımı, riskte hafif artışa neden olabilir.",
        source: "National Cancer Institute. (2022). Oral Contraceptives and Cancer Risk. https://www.cancer.gov"
    },
    {
        question: "Emzirmemek meme kanseri riskini artırır mı?",
        answer: "Evet. Emzirmek, meme kanseri riskini azaltan koruyucu bir faktördür. Emzirmemek riski artırabilir.",
        source: "World Health Organization. (2022). Breastfeeding and Breast Cancer. https://www.who.int"
    },
    {
        question: "Alkol ve sigara kullanmak meme kanseri riskini artırır mı?",
        answer: "Evet. Alkol ve sigara kullanımı hormonal değişiklikleri tetikleyerek riski artırır.",
        source: "International Agency for Research on Cancer. (2022). Alcohol and Breast Cancer Risk. https://www.iarc.who.int"
    },
    {
        question: "Radyasyona maruz kalmak meme kanseri için tehlikeli midir?",
        answer: "Evet. Özellikle göğüs bölgesine genç yaşta maruz kalınan radyasyon, riski artırır.",
        source: "Centers for Disease Control and Prevention. (2023). Radiation Exposure and Breast Cancer. https://www.cdc.gov"
    },
    {
        question: "Yağlı beslenme meme kanseri riskini artırır mı?",
        answer: "Evet. Doymuş yağ açısından zengin diyetlerin, özellikle obeziteye neden olduğunda, riski artırabileceği düşünülmektedir.",
        source: "Harvard T.H. Chan School of Public Health. (2023). Diet and Breast Cancer. https://www.hsph.harvard.edu"
    },
    {
        question: "Düzenli egzersiz yapmamak meme kanseri riskini etkiler mi?",
        answer: "Evet. Fiziksel aktivite eksikliği, meme kanseri dahil birçok kanser türü için risk faktörüdür.",
        source: "American Cancer Society. (2023). Physical Activity and Cancer Risk. https://www.cancer.org"
    },
    {
        question: "Kendi Kendine Meme Muayenesi (KKMM) ne sıklıkla yapılmalıdır?",
        answer: "20 yaşından itibaren her kadın ayda bir kez kendi kendine meme muayenesi yapmalıdır. Adet gören kadınlar için en uygun zaman, adet başlangıcından 5–7 gün sonra, memelerin daha yumuşak olduğu dönemdir. Menopozdaki kadınlar ise her ay aynı günü seçerek düzenli şekilde uygulamalıdır.",
        source: "Kısa, M., & Yavan, T. (2013). Kadınların kendi kendine meme muayenesini uygulama durumları ve etkileyen faktörler. Anadolu Hemşirelik ve Sağlık Bilimleri Dergisi, 16(2), 109–117."
    },
    {
        question: "KKMM uygulamasında hangi parmaklar kullanılmalıdır?",
        answer: "KKMM sırasında işaret, orta ve yüzük parmak uçları birlikte kullanılarak dairesel hareketlerle meme dokusu yoklanmalıdır. Tek parmakla veya tırnak ucu ile bastırmak doğru bir yöntem değildir ve hassas dokuları gözden kaçırmanıza neden olabilir.",
        source: "Demirkıran, F., & Özdemir, F. (2009). Kendi kendine meme muayenesine yönelik eğitimin bilgi düzeyine etkisi. Fırat Sağlık Hizmetleri Dergisi, 4(10), 77–91."
    },
    {
        question: "KKMM sırasında en sık yapılan hatalardan biri nedir?",
        answer: "En sık yapılan hatalardan biri meme başının muayene dışı bırakılması ya da sadece yüzeysel kontrol yapılmasıdır. Oysa meme başı da dahil olmak üzere tüm meme dokusu ve koltuk altı bölgesi dikkatle kontrol edilmelidir. Ayrıca muayene sırasında yalnızca ayakta uygulama yapmak da eksik muayeneye neden olabilir.",
        source: "Yılmaz, M., & Aksu, H. (2010). Kadınların meme kanseri ve erken tanı yöntemlerine ilişkin bilgi düzeylerinin belirlenmesi. T.C. Sağlık Bakanlığı Yayını."
    },
    {
        question: "Kendi Kendine Meme Muayenesi (KKMM) ne zaman başlanmalıdır?",
        answer: "KKMM'ye 20 yaşından itibaren başlanması önerilir. Bu yaşlardan itibaren kadınların kendi meme dokularını tanımaları, olası değişiklikleri erken fark etmeleri açısından önemlidir. Erken yaşta kazanılan bu alışkanlık, meme sağlığı farkındalığını artırır.",
        source: "American Cancer Society. (2023). Breast Self-Exam. https://www.cancer.org/cancer/breast-cancer/breast-self-exam.html"
    },
    {
        question: "HRT (Hormon Replasman Tedavisi) ne zaman kullanılır?",
        answer: "HRT, özellikle menopoz döneminde şiddetli sıcak basması, gece terlemeleri, vajinal kuruluk, uykusuzluk gibi yaşam kalitesini düşüren semptomları hafifletmek için kullanılır. Genellikle menopozun ilk yıllarında kısa süreli kullanım önerilir.",
        source: "North American Menopause Society. (2022). The 2022 hormone therapy position statement. https://www.menopause.org"
    },
    {
        question: "HRT süresi ne kadar olmalıdır?",
        answer: "HRT'nin mümkün olan en düşük dozda ve en kısa sürede kullanılması önerilir. Genellikle 5 yılı geçmemesi tavsiye edilir; uzun süreli kullanımda meme kanseri ve kardiyovasküler riskler artabilir.",
        source: "Stuenkel, C. A. et al. (2015). Treatment of Symptoms of the Menopause: An Endocrine Society Clinical Practice Guideline. J Clin Endocrinol Metab, 100(11), 3975–4011."
    },
    {
        question: "HRT herkes için uygun mudur?",
        answer: "Hayır. HRT; meme kanseri öyküsü, damar tıkanıklığı, karaciğer hastalığı olan kadınlarda önerilmez. Her bireyin riskleri değerlendirilerek hekim kararı ile başlanmalıdır.",
        source: "American College of Obstetricians and Gynecologists (ACOG). (2022). HRT Guidelines. https://www.acog.org"
    },
    {
        question: "Menopoz döneminde gece terlemesi yaşamak normal midir?",
        answer: "Evet. Gece terlemesi menopozun vazomotor semptomları arasındadır ve östrojen seviyelerinin azalmasıyla sık görülür.",
        source: "Mayo Clinic. (2023). Menopause: Symptoms & causes. https://www.mayoclinic.org"
    },
    {
        question: "Menopoz döneminde sıcak basması ne kadar sürer?",
        answer: "Sıcak basması genellikle menopozun ilk yıllarında yoğun hissedilir ve ortalama 4–5 yıl sürebilir. Bazı kadınlarda 10 yıla kadar da devam edebilir.",
        source: "Freeman, E. W. (2014). Duration of menopausal hot flushes. JAMA Internal Medicine, 174(4), 500–503."
    },
    {
        question: "Menopoz döneminde eklem ağrıları normal midir?",
        answer: "Evet. Düşen östrojen seviyesi nedeniyle eklem ve kas ağrıları, özellikle sabahları daha belirgin olabilir.",
        source: "National Institute on Aging. (2022). Menopause symptoms and treatment. https://www.nia.nih.gov"
    },
    {
        question: "Menopozda deride kuruluk ve kaşıntı görülmesi normal midir?",
        answer: "Evet. Östrojenin azalmasıyla cilt elastikiyeti ve nemi azalır, bu da kuruluk ve kaşıntıya neden olabilir. Nemlendirici ürünler ve uygun cilt bakımı önerilir.",
        source: "International Menopause Society. (2021). Skin and Menopause Report. https://www.imsociety.org"
    },
    {
        question: "Mamografi çektirirsem ve hiçbir şey bulunmazsa meme kanseri ile ilgili daha fazla endişelenmem gerekmez mi?",
        answer: "Hayır. Mamografi taramaları düzenli aralıklarla yapılmalıdır. Bir tarama temiz çıksa bile gelecekte risk devam edebilir. Bu nedenle düzenli kontroller önemlidir.",
        source: "American Cancer Society. (2023). Mammogram Benefits. https://www.cancer.org"
    },
    {
        question: "Mamografi mememdeki kitlelerin erken bulunmasına yardımcı olur mu?",
        answer: "Evet. Mamografi, meme kanserini semptomlar ortaya çıkmadan çok önce tespit edebilir.",
        source: "World Health Organization. (2022). Breast cancer: early diagnosis. https://www.who.int"
    },
    {
        question: "Mamografide kitle bulunursa, tedavim daha kolay olabilir mi?",
        answer: "Evet. Erken evrede yakalanan meme kanserlerinde tedavi başarı oranı çok daha yüksektir.",
        source: "National Cancer Institute. (2022). Breast Cancer Treatment (PDQ®). https://www.cancer.gov"
    },
    {
        question: "Mememdeki en küçük kitleyi tespit etmek için mamografi en iyi yol mudur?",
        answer: "Evet. Mamografi, fiziksel muayene ile hissedilemeyecek kadar küçük kitleleri dahi gösterebilir.",
        source: "American College of Radiology. (2022). Mammography Saves Lives. https://www.acr.org"
    },
    {
        question: "Mamografi çektirmek meme kanserinden ölme riskini azaltır mı?",
        answer: "Evet. Mamografi ile yapılan erken teşhis, yaşam süresini uzatabilir ve mortaliteyi azaltır.",
        source: "European Breast Guidelines. (2023). https://healthcare-quality.jrc.ec.europa.eu"
    },
    {
        question: "Mamografi çektirmekten korkuyorum çünkü kötü bir şey çıkmasından endişeliyim. Bu normal mi?",
        answer: "Bu duygu yaygındır, ancak unutmayın ki erken teşhis hayat kurtarır. Korkularınızı bir sağlık uzmanı ile paylaşabilirsiniz.",
        source: "Mayo Clinic. (2023). Breast cancer screening. https://www.mayoclinic.org"
    },
    {
        question: "Mamografi işlemi sırasında ne yapılacağını bilmiyorum. Bu yüzden çekiniyorum.",
        answer: "İşlem kısa sürer ve radyoloji teknisyenleri sizi her adımda bilgilendirir. Süreç hakkında önceden bilgi edinmek endişenizi azaltabilir.",
        source: "BreastCancer.org. (2022). What to Expect During a Mammogram. https://www.breastcancer.org"
    },
    {
        question: "Mamografi çektirmenin ağrılı olduğunu duydum. Bu doğru mu?",
        answer: "Bazı kadınlar hafif rahatsızlık hissedebilir, ancak işlem sadece birkaç saniye sürer. Acı kişiden kişiye değişir.",
        source: "NHS UK. (2023). Mammogram Information. https://www.nhs.uk"
    },
    {
        question: "Mamografi çektirmek için nereye başvuracağımı bilmiyorum.",
        answer: "Aile sağlığı merkezinizden ya da en yakın devlet hastanesinden yönlendirme alabilirsiniz. Ücretsiz taramalar belirli yaş grupları için sunulmaktadır.",
        source: "T.C. Sağlık Bakanlığı (2023). Kanser Erken Teşhis, Tarama ve Eğitim Merkezleri (KETEM). https://hsgm.saglik.gov.tr"
    },
    {
        question: "Mamografi çok zaman alır mı?",
        answer: "Hayır. Mamografi işlemi genellikle 15 dakika içinde tamamlanır. Sonuçların çıkması da birkaç gün sürer.",
        source: "CDC (Centers for Disease Control and Prevention). (2023). Mammography. https://www.cdc.gov"
    },
    {
        question: "Ailede meme kanseri öyküsü meme kanseri riskini artırır mı?",
        answer: "Evet. Anne, kız kardeş veya teyze gibi birinci derece akrabalarda meme kanseri öyküsü olan kişilerde risk artar.",
        source: "Centers for Disease Control and Prevention (CDC). (2022). Breast Cancer Risk Factors."
    },
    {
        question: "Ailede diğer kanser türlerinin olması meme kanseri riskini etkiler mi?",
        answer: "Bazı kalıtsal sendromlar (örneğin BRCA1/2 mutasyonları) hem meme hem de yumurtalık gibi kanser türlerinin birlikte görülmesine neden olabilir.",
        source: "National Cancer Institute. (2023). BRCA Mutations. https://www.cancer.gov"
    },
    {
        question: "Kronik hastalıklar meme kanseri riskine nasıl etki eder?",
        answer: "Hipotiroidi, tip 2 diyabet ve hipertansiyon gibi bazı hastalıklar ile meme kanseri riski arasında ilişkiler bulunabilir; ancak kesin mekanizmalar halen araştırılmaktadır.",
        source: "American Institute for Cancer Research. (2020). Chronic Disease and Cancer."
    }
];

const FAQPage = () => {
    const [openItems, setOpenItems] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const toggleItem = (index) => {
        setOpenItems(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Arama fonksiyonları
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
    };

    const clearSearch = () => {
        setSearchTerm('');
    };

    // Arama sonuçlarını filtrele
    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredData(faqData);
        } else {
            const filtered = faqData.filter(item =>
                item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.answer.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        }
    }, [searchTerm]);

    // Başlangıçta tüm veriyi göster
    useEffect(() => {
        setFilteredData(faqData);
    }, []);

    return (
        <div className="faq-container">
            <div className="faq-header">
                <div className="faq-header-content">
                    <h1>Sık Sorulan Sorular</h1>
                    <p>Meme sağlığı, risk faktörleri, erken tanı yöntemleri ve korunma stratejileri hakkında merak ettiğiniz birçok şeyi burada bulabilirsiniz.</p>
                </div>
            </div>

            <div className="faq-content">
                <div className="search-section-header">
                    <div className="search-container-header">
                        <div className="search-input-wrapper-header">
                            <input
                                type="text"
                                placeholder="Sorularınızı buraya yazın..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className="search-input-header"
                            />
                            <div className="search-icons-header">
                                <span className="search-icon-header">🔍</span>
                                {searchTerm && (
                                    <button onClick={clearSearch} className="clear-button-header">
                                        ×
                                    </button>
                                )}
                            </div>
                        </div>
                        {searchTerm && (
                            <div className="search-results-info-header">
                                {filteredData.length} sonuç bulundu
                            </div>
                        )}
                    </div>
                </div>

                <div className="faq-list">
                    {filteredData.map((item, index) => (
                        <div key={index} className={`faq-item ${openItems[index] ? 'active' : ''}`}>
                            <div
                                className="faq-question"
                                onClick={() => toggleItem(index)}
                            >
                                <h3>
                                    <span className="question-number">{index + 1}</span>
                                    {item.question}
                                </h3>
                                <span className="faq-icon">
                                    {openItems[index] ? '−' : '+'}
                                </span>
                            </div>

                            {openItems[index] && (
                                <div className="faq-answer">
                                    <div className="answer-content">
                                        <p><strong>Cevap:</strong> {item.answer}</p>
                                        <p className="source"><strong>Kaynak:</strong> {item.source}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="faq-footer">
                    <div className="contact-info">
                        <h3>Daha fazla bilgi için</h3>
                        <p>Sorularınız için MeduVR platformumuzda yer alan eğitim içeriklerini inceleyebilir veya sağlık profesyonellerinizle iletişime geçebilirsiniz.</p>
                        <div className="faq-buttons">
                            <a href="/courses" className="btn-primary">Eğitim İçeriklerimizi İnceleyin</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQPage;
